import { styled, css } from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const StyledTableOuter = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 1rem 0.5rem;

  ${media.md} {
    padding: 0.5rem 0;
  }
`;

export const StyledTable = styled.div`
  padding: 1rem 0.5rem;
  border-radius: 1rem;
  font-size: calc(0.75rem + 0.4vw);
  min-width: min(100%, 45rem);

  ${media.md} {
    font-size: 0.8125rem;
    border-radius: 0.5rem;
  }
`;

export const StyledRow = styled.div<{ isHeader?: boolean; columns?: string }>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns};
  padding: 2vh 0;
  min-width: 36rem;

  ${media.md} {
    min-width: 32rem;
    padding: 1rem 0;
  }

  ${(props) =>
    props.isHeader &&
    css`
      color: #8c918c;
      padding-bottom: 4vh;

      ${media.md} {
        padding-bottom: 1rem;
      }
    `}

  ${(props) =>
    !props.isHeader &&
    css`
      border-top: 1px solid #e7efff;
      & > span:nth-child(1) {
        font-weight: 600;
      }
    `}

  .nested_cell {
    overflow-wrap: anywhere;
  }

  .nested_cell > span:nth-child(3) {
    display: inline-block;
    color: #aabdad;
    font-weight: 400;
    padding-top: 2%;
  }

  svg {
    cursor: pointer;
  }
`;

export const StyledActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const StyledBadge = styled.span<{ $color: string; $background: string }>`
  display: inline-flex;
  align-self: baseline;

  & > span {
    color: ${({ $color }) => $color};
    background: ${({ $background }) => $background};
    border-radius: 8px;
    padding: 10px;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.2;
    text-transform: lowercase;
  }

  & > span::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledCopyButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #007bff;
  position: absolute;
  left: -5px;
  top: -1.5rem;
  padding: 0;
`;
